import { useState } from 'react';
import { LogIn } from 'lucide-react';
import { formatRoomCode, validateRoomCode } from '@utils/roomCode';

export default function JoinRoomForm({ onJoin, loading }) {
  const [code, setCode] = useState('');

  const handleChange = (e) => {
    setCode(formatRoomCode(e.target.value));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateRoomCode(code) || loading) return;
    onJoin(code);
  };

  return (
    <form onSubmit={handleSubmit}>
      <label className="block text-sm font-medium text-charcoal mb-2">Room code</label>
      <input
        type="text"
        value={code}
        onChange={handleChange}
        placeholder="XXXXXXXX"
        maxLength={8}
        className="w-full px-4 py-3 rounded-xl border border-slate-200 bg-canvas text-charcoal text-center text-xl tracking-[0.3em] font-mono placeholder:text-slate-400 placeholder:tracking-[0.3em] focus:outline-none focus:ring-2 focus:ring-amber/50 focus:border-amber uppercase"
      />
      <button
        type="submit"
        disabled={!validateRoomCode(code) || loading}
        className="mt-4 w-full flex items-center justify-center gap-2 px-4 py-3 rounded-xl bg-amber text-white font-medium font-display hover:bg-amber-dark transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
      >
        <LogIn className="w-5 h-5" />
        {loading ? 'Joining...' : 'Join Room'}
      </button>
    </form>
  );
}
